/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum RuleSetType {
  TriageEntry = 'triageEntry',
  Navigation = 'navigation',
  Messaging = 'messaging'
}
